<div class="main-layout">
  <header></header>

  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</div>